module.exports = __webpack_public_path__ + "assets/img/paraf@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/paraf@2x.png
// module id = 139
// module chunks = 0